/* unplugin-vue-components disabled */import { render } from "./ExamInfoModal.vue?vue&type=template&id=1a5fc240&scoped=true&ts=true"
import script from "./ExamInfoModal.vue?vue&type=script&lang=ts"
export * from "./ExamInfoModal.vue?vue&type=script&lang=ts"

import "./ExamInfoModal.vue?vue&type=style&index=0&id=1a5fc240&lang=less&scoped=true"

import exportComponent from "/project/node_modules/.pnpm/vue-loader@16.7.0_@vue+compiler-sfc@3.2.23_vue@3.2.23_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5fc240"]])